module.exports = __webpack_public_path__ + "img/menu_btn.682a544a.png";